import React from "react";
import { Modal, Icon } from "semantic-ui-react";
import TickerShare from "../TickerShare/TickerShare";
const TickerModal = () => {
  const [open, setOpen] = React.useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  return (
    <Modal
      onClose={() => setOpen(false)}
      // centered={false}
      closeIcon
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <div>
          Add Ticker{" "}
          <Icon
            name="ticket"
            size="small"
            style={{ color: "var(--watchlist)" }}
          />
        </div>
      }
    >
      <TickerShare handleCloseModal={handleCloseModal} />
    </Modal>
  );
};

export default TickerModal;
